import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {  getAllCOE } from '../../../services/adminServices/CoeServices';
import { toast } from 'react-toastify';
import EditAdminModal from './EditAdminModal';
import AdminTable from './AdminTable';
import { getAllAdmins } from '../../../services/adminServices/AdminServices';

const AddAdmin = () => {
    const [openModal, setOpenModal] = useState({ userForm: false });
    const [rowData, setRowData] = useState();
    const [allCOE, setCOE] = useState([]);
    const [editRowData, setEditRowData] = useState(null);
    const [userName, setUserName] = useState("")
    const [search, setSearch] = useState("");

    const handleModalToggle = (modalName, data = null) => {
        setOpenModal((prev) => ({ ...prev, [modalName]: !prev[modalName] }));
        if (!data) {
            setEditRowData(null);
        } else {
            setEditRowData(data);
        }
    };

    const getAllUsersData = async () => {
        try {
            const response = await getAllAdmins();
            setRowData(response?.data?.data);
            const allCOE = await getAllCOE();
            setCOE(allCOE.data.data)
        } catch (error) {
            toast.error(error?.response?.data.message || error?.message || error?.error);
        }
    }

    const handleEditClick = (row) => {
        handleModalToggle('userForm', row);
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"))
        setUserName(user?.name)
        getAllUsersData();
    }, []);

    return (
        <Box className="dashboard-container">
            <Box className="dashboard-header">
                <Typography className="dashboard-header-title">Welcome {userName}</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <TextField
                        sx={{ width: { xs: "100%", sm: "300px" }, backgroundColor: "#fff", borderRadius: "8px" }}
                        size="small"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleModalToggle('userForm')}
                        className="dashboard-header-button PH-title">
                        ADD ADMIN
                    </Button>
                </Box>
            </Box>
            <EditAdminModal
                open={openModal.userForm}
                onClose={() => handleModalToggle('userForm')}
                title={"Head"}
                rowData={editRowData}
                allCOE={allCOE}
                getAllUsersData={getAllUsersData}
            />
            <Box className="dashboard-box-container">
                <AdminTable
                    rows={rowData}
                    allCOE={allCOE}
                    onEditClick={handleEditClick}
                    getAllUsersData={getAllUsersData}
                    search={search}
                />
            </Box>
        </Box>
    );
};

export default AddAdmin;
